import React, { useState } from 'react';
import { Player, PlayerEvent } from '@lottiefiles/react-lottie-player';
import { cn } from '@/utils/styles';
import { HealthReferenceSection } from '@screens/HealthPages/HealthReferenceSection';

interface GutOralDetailsCardProps {
  mainText: string;
  isMainTextPercentage?: boolean;
  subText: string;
  subTextColor?: string;
  videoSrc: any;
  fallBackVdo: string;
  scoreId?: number;
}

export const GutOralDetailsCard: React.FC<GutOralDetailsCardProps> = ({
  mainText,
  subText,
  subTextColor,
  isMainTextPercentage,
  videoSrc,
  fallBackVdo,
  scoreId,
}) => {
  const [isS3Loaded, setIsS3Loaded] = useState(false);

  const handleOnEvent = (e: PlayerEvent) => {
    if (e === 'load') {
      setIsS3Loaded(true);
    }
  };

  return (
    <div className="h-full cursor-auto select-none">
      {videoSrc && (
        <>
          <div className="h-[26rem] relative">
            <div className="absolute inset-0 overflow-hidden">
              {!isS3Loaded && (
                <Player
                  autoplay
                  loop
                  src={fallBackVdo}
                  className="rounded-lg object-cover"
                  style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    height: '100%',
                    width: '100%',
                  }}
                />
              )}
              <Player
                autoplay
                loop
                src={videoSrc}
                className="rounded-lg object-cover"
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  height: '100%',
                  width: '100%',
                  display: isS3Loaded ? 'block' : 'none',
                }}
                onEvent={handleOnEvent}
              />
            </div>
            <div className="absolute inset-0 flex flex-col justify-center items-center">
              <p
                className={cn(
                  'dark text-primary font-serif',
                  isMainTextPercentage
                    ? 'typography-num-xlarge'
                    : 'typography-d1',
                )}
              >
                {mainText}
              </p>
              <p
                className="dark typography-body text-primary"
                style={{ color: subTextColor }}
              >
                {subText}
              </p>
            </div>
          </div>
          {scoreId && (
            <div className="text-center flex items-center justify-center">
              <HealthReferenceSection variant="light" scoreId={scoreId} />
            </div>
          )}
        </>
      )}
    </div>
  );
};
